import { NgModule } from '@angular/core';
import { CommonModule, TitleCasePipe } from '@angular/common';
import {
  RmSelectDateComponent,
  SearchFilterPipe,
} from './rm-select-date.component';
import { TranslateModule } from '@ngx-translate/core';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { RomaToolTipModule } from '@web-frontend/shared/directives/roma-tooltip';
import { MatMenuModule } from '@angular/material/menu';
import { RmBadgeModule } from '../rm-badge';
import { RmSelectRegisterModule } from '../rm-select-register';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatFormFieldModule } from '@angular/material/form-field';
import { ClickOutsideDirectiveModule } from '../../../directives/click-outside';

@NgModule({
  declarations: [RmSelectDateComponent, SearchFilterPipe],
  imports: [
    CommonModule,
    TranslateModule.forChild(),
    MatProgressSpinnerModule,
    MatCheckboxModule,
    RomaToolTipModule,
    MatMenuModule,
    RmBadgeModule,
    FormsModule,
    MatFormFieldModule,
    ReactiveFormsModule,
    RmSelectRegisterModule,
    MatDatepickerModule,
    MatInputModule,
    ClickOutsideDirectiveModule,
  ],
  providers: [TitleCasePipe],
  exports: [RmSelectDateComponent],
})
export class RmSelectDateModule {}
